// extracted by mini-css-extract-plugin
module.exports = {"storyblok-list":"StoryblokList_storyblok-list__a7qX_"};